import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { IStepper } from "../../../../shared/model/IStepper";
import { ButtonsGroup } from "../ButtonsGroup";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
  placeholderNoOptions,
  placeholderSelectSimple,
} from "../../../../shared/helpers/placeHolders";
import { ErrorMessage } from "formik";
import { yesNoEnum } from "../../../../shared/selectors/yesNoEnum";
import { to_ISelect_Enum } from "../../../../shared/mutator/dataTransformSelect";
import { operationSystemEnum } from "../../../../shared/selectors/operatingSystemEnum";
import { internetSpeedEnum } from "../../../../shared/selectors/internetSpeedEnum";
import { customStyles } from "../custom-selector-styles";
import { YesNo } from "../../../../shared/model/enumerations/yes-no.model";
import { OperatingSystem } from "../../../../shared/model/enumerations/operating-system.model";
import { InternetSpeed } from "../../../../shared/model/enumerations/internet-speed.model";

interface IProps {
  formik: any;
  showErrorsInputs: boolean;
}

const animatedComponents = makeAnimated();
export const InformationResource = (props: IProps) => {
  const { formik } = props;
  const validateRequiredfields = () => {};
  return (
    <>
      {/* Recurso informaticos */}
      <Row className="title-form not-first-title">Recursos informáticos</Row>
      <Row className="container-inputs-form">
        <Col>
          <FormGroup>
            <Label
              className={
                (formik.touched?.techResource?.remoteWork ||
                  props.showErrorsInputs) &&
                formik.errors?.techResource?.remoteWork &&
                !(
                  formik.values?.techResource?.remoteWork &&
                  formik.values?.techResource?.remoteWork !== null
                )
                  ? "text-danger"
                  : ""
              }
            >
              Disponibilidad remoto*
            </Label>
            <Select
              name="techResource.remoteWork"
              placeholder={placeholderSelectSimple()}
              noOptionsMessage={() => placeholderNoOptions()}
              components={animatedComponents}
              options={yesNoEnum()}
              value={to_ISelect_Enum(
                formik.values.techResource.remoteWork,
                yesNoEnum()
              )}
              onChange={async (e: any) => {
                await formik.setFieldValue("techResource.remoteWork", e.value);
                const errors = formik.errors;
                if (errors?.techResource?.remoteWork) {
                  delete errors.techResource.remoteWork;
                }
                if (Object.keys(errors?.techResource).length === 0) {
                  delete errors.techResource;
                }
                await formik.setErrors(errors);
              }}
              onBlur={formik.handleBlur("techResource.remoteWork")}
              className={`select-postulate ${
                (formik.touched?.techResource?.remoteWork ||
                  props.showErrorsInputs) &&
                formik.errors?.techResource?.remoteWork &&
                !(
                  formik.values?.techResource?.remoteWork &&
                  formik.values?.techResource?.remoteWork !== null
                )
                  ? "is-invalid"
                  : ""
              }`}
              styles={customStyles}
            />
            {(formik.touched?.techResource?.remoteWork ||
              props.showErrorsInputs) &&
              formik.errors?.techResource?.remoteWork &&
              !(
                formik.values?.techResource?.remoteWork &&
                formik.values?.techResource?.remoteWork !== null
              ) && (
                <div className="invalid-feedback">
                  {formik.errors.techResource.remoteWork}
                </div>
              )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label
              className={
                (formik.touched?.techResource?.ownComputer ||
                  props.showErrorsInputs) &&
                formik.errors?.techResource?.ownComputer &&
                !(
                  formik.values?.techResource?.ownComputer &&
                  formik.values?.techResource?.ownComputer !== null
                )
                  ? "text-danger"
                  : ""
              }
            >
              Computadora propia*
            </Label>
            <Select
              name="techResource.ownComputer"
              placeholder={placeholderSelectSimple()}
              noOptionsMessage={() => placeholderNoOptions()}
              components={animatedComponents}
              options={yesNoEnum()}
              value={to_ISelect_Enum(
                formik.values.techResource.ownComputer,
                yesNoEnum()
              )}
              onChange={async (e: any) => {
                if (e.value === YesNo.NO) {
                  await formik.setFieldValue(
                    "techResource.operatingSystem",
                    OperatingSystem.NONE
                  );
                }
                await formik.setFieldValue("techResource.ownComputer", e.value);
                const errors = formik.errors;
                if (errors?.techResource?.ownComputer) {
                  delete errors.techResource.ownComputer;
                }
                if (Object.keys(errors?.techResource).length === 0) {
                  delete errors.techResource;
                }
                await formik.setErrors(errors);
              }}
              onBlur={formik.handleBlur("techResource.ownComputer")}
              className={`select-postulate ${
                (formik.touched?.techResource?.ownComputer ||
                  props.showErrorsInputs) &&
                formik.errors?.techResource?.ownComputer &&
                !(
                  formik.values?.techResource?.ownComputer &&
                  formik.values?.techResource?.ownComputer !== null
                )
                  ? "is-invalid"
                  : ""
              }`}
              styles={customStyles}
            />
            {(formik.touched?.techResource?.ownComputer ||
              props.showErrorsInputs) &&
              formik.errors?.techResource?.ownComputer &&
              !(
                formik.values?.techResource?.ownComputer &&
                formik.values?.techResource?.ownComputer !== null
              ) && (
                <div className="invalid-feedback">
                  {formik.errors.techResource.ownComputer}
                </div>
              )}
          </FormGroup>
        </Col>
      </Row>
      <Row className="container-inputs-form">
        <Col xs="6">
          <FormGroup>
            <Label
              className={
                (formik.touched?.techResource?.internet ||
                  props.showErrorsInputs) &&
                formik.errors?.techResource?.internet &&
                !(
                  formik.values?.techResource?.internet &&
                  formik.values?.techResource?.internet !== null
                )
                  ? "text-danger"
                  : ""
              }
            >
              Internet*
            </Label>
            <Select
              name="techResource.internet"
              placeholder={placeholderSelectSimple()}
              noOptionsMessage={() => placeholderNoOptions()}
              components={animatedComponents}
              options={yesNoEnum()}
              value={to_ISelect_Enum(
                formik.values.techResource.internet,
                yesNoEnum()
              )}
              onChange={async (e: any) => {
                if (e.value === YesNo.NO) {
                  await formik.setFieldValue(
                    "techResource.internetSpeed",
                    InternetSpeed.NONE
                  );
                }
                await formik.setFieldValue("techResource.internet", e.value);
                const errors = formik.errors;
                if (errors?.techResource?.internet) {
                  delete errors.techResource.internet;
                }
                if (Object.keys(errors?.techResource).length === 0) {
                  delete errors.techResource;
                }
                await formik.setErrors(errors);
              }}
              onBlur={formik.handleBlur("techResource.internet")}
              className={`select-postulate ${
                (formik.touched?.techResource?.internet ||
                  props.showErrorsInputs) &&
                formik.errors?.techResource?.internet &&
                !(
                  formik.values?.techResource?.internet &&
                  formik.values?.techResource?.internet !== null
                )
                  ? "is-invalid"
                  : ""
              }`}
              styles={customStyles}
            />
            {(formik.touched?.techResource?.internet ||
              props.showErrorsInputs) &&
              formik.errors?.techResource?.internet &&
              !(
                formik.values?.techResource?.internet &&
                formik.values?.techResource?.internet !== null
              ) && (
                <div className="invalid-feedback">
                  {formik.errors.techResource.internet}
                </div>
              )}
          </FormGroup>
        </Col>
        {formik.values.techResource.ownComputer === "YES" && (
          <Col>
            <FormGroup>
              <Label>Sistema operativo</Label>
              <Select
                isClearable
                name="techResource.operatingSystem"
                placeholder={placeholderSelectSimple()}
                noOptionsMessage={() => placeholderNoOptions()}
                components={animatedComponents}
                options={operationSystemEnum()}
                value={to_ISelect_Enum(
                  formik.values.techResource.operatingSystem,
                  operationSystemEnum()
                )}
                onChange={(e: any) => {
                  formik.setFieldValue(
                    "techResource.operatingSystem",
                    e?.value ? e.value : OperatingSystem.NONE
                  );
                }}
                onBlur={formik.handleBlur("techResource.operatingSystem")}
                className={`select-postulate`}
                styles={customStyles}
              />
            </FormGroup>
          </Col>
        )}
      </Row>
      {formik.values.techResource.internet === "YES" && (
        <Row className="container-inputs-form">
          <Col md="6">
            <FormGroup>
              <Label>Velocidad de internet</Label>
              <Select
                isClearable
                name="techResource.internetSpeed"
                placeholder={placeholderSelectSimple()}
                noOptionsMessage={() => placeholderNoOptions()}
                components={animatedComponents}
                options={internetSpeedEnum()}
                value={to_ISelect_Enum(
                  formik.values.techResource.internetSpeed,
                  internetSpeedEnum()
                )}
                onChange={(e: any) => {
                  formik.setFieldValue(
                    "techResource.internetSpeed",
                    e?.value ? e.value : InternetSpeed.NONE
                  );
                }}
                className={`select-postulate`}
                onBlur={formik.handleBlur("techResource.internetSpeed")}
                styles={customStyles}
              />
            </FormGroup>
          </Col>
        </Row>
      )}
    </>
  );
};
